// useBookLinkOpen — the wire from `?book=<key>` to the Collection Book (ORD-BOOK-1, CLB-104).
//
// Same shape as useNamesLinkOpen: the address is captured at MODULE LOAD, because a reader who
// is signed out signs in first and only then does the shell mount; consumed once per page load
// (AppOverlays remounts on every entryPhase change). Only a known book key counts.
//
// Fail-closed: only a reader with Orders access gets the book; anyone else keeps the screen
// they landed on and the `book` parameter is removed from the address.

import { useEffect } from 'react';
import { usePortalPermissions, canAccessPortal } from './usePortalPermissions';
import { openBook } from '../portals/book/bookStore';
import { wantedBook } from '../portals/book/bookLink';

const WANTED = (() => { try { return wantedBook(window.location.search); } catch (_) { return null; } })();
let consumed = false;

/** Pure: whether this permissions payload may open the book. */
export const bookLinkAllowed = (data) => !!data && canAccessPortal(data, 'orders');

export function useBookLinkOpen() {
  const { data, isLoading } = usePortalPermissions();
  useEffect(() => {
    if (!WANTED || consumed || isLoading || !data) return;
    consumed = true;
    if (!bookLinkAllowed(data)) {
      try {
        const u = new URL(window.location.href);
        u.searchParams.delete('book');
        window.history.replaceState(window.history.state, '', `${u.pathname}${u.search}${u.hash}`);
      } catch (_) { /* cosmetic */ }
      return;
    }
    openBook(WANTED);
  }, [data, isLoading]);
}

export default useBookLinkOpen;
